import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ExportPanel = ({ onExport }) => {
  const [exportFormat, setExportFormat] = useState('pdf');
  const [isExporting, setIsExporting] = useState(false);

  const exportFormats = [
    { value: 'pdf', label: 'PDF Report', icon: 'FileText' },
    { value: 'excel', label: 'Excel Spreadsheet', icon: 'FileSpreadsheet' },
    { value: 'csv', label: 'CSV Data', icon: 'FileDown' },
    { value: 'json', label: 'JSON Data', icon: 'Code' }
  ];

  const handleExport = async () => {
    setIsExporting(true);
    try {
      await onExport(exportFormat);
      setTimeout(() => {
        setIsExporting(false);
      }, 2000);
    } catch (error) {
      console.error('Export failed:', error);
      setIsExporting(false);
    }
  };

  return (
    <div className="card">
      <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6">
        <Icon name="Download" size={20} className="text-primary md:w-6 md:h-6" />
        <h3 className="text-lg md:text-xl font-semibold text-foreground">
          Export Data
        </h3>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3 mb-4 md:mb-6">
        {exportFormats?.map((format) => (
          <button
            key={format?.value}
            onClick={() => setExportFormat(format?.value)}
            className={`flex flex-col items-center gap-2 p-3 md:p-4 rounded-lg border-2 transition-all duration-250 ${
              exportFormat === format?.value
                ? 'border-primary bg-primary/10' :'border-border hover:border-primary/50'
            }`}
          >
            <Icon
              name={format?.icon}
              size={20}
              className={`md:w-6 md:h-6 ${
                exportFormat === format?.value ? 'text-primary' : 'text-muted-foreground'
              }`}
            />
            <span
              className={`text-xs md:text-sm font-medium text-center ${
                exportFormat === format?.value ? 'text-primary' : 'text-foreground'
              }`}
            >
              {format?.label}
            </span>
          </button>
        ))}
      </div>
      <Button
        variant="default"
        fullWidth
        loading={isExporting}
        iconName="Download"
        iconPosition="left"
        onClick={handleExport}
      >
        {isExporting ? 'Exporting...' : `Export as ${exportFormat?.toUpperCase()}`}
      </Button>
      <div className="mt-4 md:mt-6 pt-4 md:pt-6 border-t border-border">
        <div className="flex items-start gap-2 md:gap-3 text-xs md:text-sm text-muted-foreground">
          <Icon name="Info" size={16} className="flex-shrink-0 mt-0.5" />
          <p>
            Exported data includes all visible metrics and filters applied. Large datasets may
            take a few moments to process.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ExportPanel;